<template>
  <IadWrapper>
    <IadTitle
      class="pb-l"
      variant="large"
      tag="h2"
      :text="$t('agent.landing.reinsurance.title')"
    />
    <p
      class="text-2xl"
      v-text="$t('agent.landing.reinsurance.infos')"
    />
  </IadWrapper>
</template>
